declare namespace $ {

	export class $bog_card_icon_telegram extends $mol_icon {
		path( ): string
	}
	
	export class $bog_card_icon_arrow extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=icon.view.tree.d.ts.map